import { deviceTypes } from '../enums/deviceTypes';
import { responsiveAction } from './responsive-slice';

export const checkWindowSize = () => (dispatch) => {

    const handleResize = () => {
        let newWindowSize;
        if (window.innerWidth > 1100) {
            newWindowSize = deviceTypes.desktop;
        }
        else
            if (window.innerWidth > 900) {
                newWindowSize = deviceTypes.laptop;
            }
            else
                if (window.innerWidth > 600) {
                    newWindowSize = deviceTypes.tablet;
                }
                else {
                    newWindowSize = deviceTypes.mobile;
                }
        dispatch(responsiveAction.setWindowSize(newWindowSize));
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => {
        window.removeEventListener('resize', handleResize);
    };
};